export default {
  loadingSpinnerDark32: new URL('./loading-spinner-dark-32.gif', import.meta.url).href,
  loadingSpinnerDark64: new URL('./loading-spinner-dark-64.gif', import.meta.url).href,
  loadingSpinnerDarkSmall: new URL('./loading-spinner-dark-small.gif', import.meta.url).href,
  loadingSpinnerLight32: new URL('./loading-spinner-light-32.gif', import.meta.url).href,
  loadingSpinnerLight64: new URL('./loading-spinner-light-64.gif', import.meta.url).href
};
